export default {
  date: 'M/D/YYYY',
  datetime: 'M/D/YYYY h:mm a',
  time: 'h:mm a',
};
